import React from 'react';
import PropTypes from 'prop-types';

const NewIcon = ({ number, classes }) => (
  <div className={`new-icon bg-green pos-relative ${classes}`}>
    <span className="new-icon__number like-small color-white fw-bold position-absolute">{number}</span>
  </div>
);

NewIcon.propTypes = {
  number: PropTypes.number,
  classes: PropTypes.string,
};

export default NewIcon;



// WEBPACK FOOTER //
// ./library/app/components/Global/Icons/NewIcon.js